import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6" data-testid="not-found-page">
      <Compass className="w-10 h-10 text-[#7C3AED] mb-4" />
      <p className="overline text-[#7C3AED] mb-2">404</p>
      <h1 className="font-heading font-bold text-3xl sm:text-4xl text-[#1E1560] tracking-tight">This page isn't in the test plan.</h1>
      <p className="text-secondary mt-3 max-w-md">The address you followed doesn't exist. Head back to Trinity and let the agents take it from here.</p>
      <Button asChild className="mt-8 rounded-full bg-[#2A1E9E] hover:bg-[#3A2DB8] text-white px-6" data-testid="not-found-home-btn"><Link to="/">Back to home</Link></Button>
    </div>
  );
}
